export default (modal, data) => {
    var speaker = new UserClass(data);

    if (typeof speaker.social_networks === 'object' && speaker.social_networks != null) {
        modal.find('[html="social_networks"]').html('').show();
        $.each(speaker.social_networks, function (i, item) {
            if (item.url) {
                if (item.url.indexOf('facebook') == -1 && item.url.indexOf('twitter') == -1) {
                    modal.find('[html="social_networks"]').append('<a class="social-share__link" target="_blank" href="' + item.url + '">' + speaker.svgSocialNetwok(item.url) + '</a>');
                }
            }
        });
    } else {
        modal.find('[html="social_networks"]').html('').hide();
    }

    if (data.photo.indexOf('storage') > -1) {
        data.photo = '<img src="' + data.photo + '" />';
    } else {
        data.photo = '';
    }

    if (data.events.length) {
        setTimeout(() => {
            items.create({
                name: 'speaker-events',
                items: {
                    data: data.events
                }
            });
        }, 500);
    }

    return modal;
}